import React from 'react';
import './styles.css';
import { View } from '@smarterservices/smarter-ui';
import { useEffect, useState } from 'react';
import { usePlayerStore } from '../../../../stores/StoreContext';
import PlayPause from '../PlayPause';
import LiveButton from '../LiveButton';
import JumpBack from '../JumpBack';
import CommentButton from '../Comment';

const OverviewHoverControls = () => {
  const [showControlsOverlay, setShowControlsOverlay] = useState(false);
  const [addAnnotationDialogOpen, setAddAnnotationDialogOpen] = useState(false);

  const showHoverControls = usePlayerStore((state) => state.showHoverControls);
  const canHaveLiveVideo = usePlayerStore((state) => state.canHaveLiveVideo);

  useEffect(() => {
    if (showHoverControls) {
      setShowControlsOverlay(true);
    } else {
      if (!addAnnotationDialogOpen) {
        setShowControlsOverlay(false);
      }
    }
  }, [showHoverControls]);

  const handleCommentOpen = () => {
    console.log('Comment Open');
    setAddAnnotationDialogOpen(true);
  };

  const handleCommentHide = () => {
    console.log('Comment Hide');
    setAddAnnotationDialogOpen(false);
  };

  return (
    <View
      as="div"
      position="absolute"
      padding="small none none none"
      withVisualDebug={false}
      className={`video-hover-controls ${showControlsOverlay ? `show` : `hide`}`}
      height="50px"
      width="100%"
      textAlign="center"
      themeOverride={{
        zIndex: 9000,
      }}
    >
      <PlayPause />
      <JumpBack />
      <CommentButton
        open={addAnnotationDialogOpen}
        onOpen={handleCommentOpen}
        onHide={handleCommentHide}
      />
      {canHaveLiveVideo && <LiveButton />}
    </View>
  );
};

export default OverviewHoverControls;
